module.exports = __webpack_public_path__ + "assets/b2.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b2.png
// module id = 605
// module chunks = 0